export const REGEXPS = {
  // Kopia wzorca z backendu (zgodność 1:1). Celowo luźny: pełną walidację adresu, łącznie
  // z domeną, robi backend na `/update-payway`. Nie zaostrzaj — front odrzucałby adresy,
  // które backend przyjmuje. Różnica zapisu względem oryginału: bez zbędnych `\_` i `\"`
  // (no-useless-escape) oraz `\s` rozpisane na znaki, które znaczy w Javie - w JS `\s` łapie też
  // spacje Unicode (NBSP, U+2000–U+200A, U+FEFF…), których backend nie przyjmie.
  emailValidator: /^([A-Za-zĘęÓóĄąŚśŁłŻżŹźĆćŃń0-9\-_.+ \t\n\v\f\r"]+)@([A-Za-zĘęÓóĄąŚśŁłŻżŹźĆćŃń0-9\-_.]+)$/,
  blikValidator: /^[0-9 ]{7}$/,
}
